import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormGroup, Checkbox } from 'react-bootstrap';
import FileUploader from '../CregFileUploader';
import { sprintf } from 'sprintf-js';
import moment from 'moment';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import { getWorkTypeNameById, getSubWorkTypeNameById } from '../../utils';
import { getWorkbookData } from '../../utils/Workbook';
import { FILEPICKER_KEY, CosyndDefaultData } from '../../constants';

class SubmitForm extends Component {
  filepicker = null;

  constructor(props) {
    super(props);

    this.state = {
      certify: false,
      uploading: false,
      uploaded: false,
      fileUpload: 'start',
    };
  }

  componentDidMount() {
    this.filepicker = require('filepicker-js');
    this.filepicker.setKey(FILEPICKER_KEY);
  }

  componentWillReceiveProps(nextProps) {
    const { status } = nextProps;

    if (
      status !== this.props.status &&
      status === actionTypes.COREG_FILE_CREATE_SUCCESS
    ) {
      this.props.hideAlert();
      this.setState({ fileUpload: 'uploaded' });
      this.props.alert('success', 'You have successfully submitted your file!');
    } else if (
      status !== this.props.status &&
      status === actionTypes.COREG_UPDATE_SUCCESS
    ) {
      this.setState({ uploading: false, uploaded: true });
    } else if (
      status !== this.props.status &&
      status === actionTypes.COREG_FILE_CREATE_ERROR
    ) {
      this.props.alert('error', 'File Upload Issue!');
    }
  }

  componentDidUpdate() {
    if (this.props.coreg) {
      this.uploadWorkbook();
    }
  }

  uploadWorkbook() {
    if (this.state.uploading || this.state.uploaded) {
      return false;
    } else {
      const wbout = this.loadWorkbook();
      if (wbout) {
        this.setState({ uploading: true }, () => this.upload(wbout));
      }
    }
  }

  handleUpload(files) {
    const { coreg, profile } = this.props;
    this.props.hideAlert();

    if (coreg) {
      const coregFile = {
        coreg: coreg.id,
        email: profile.email || '',
        description: '',
        confirmNumber: sprintf('%06d', coreg.id),
        file_url: files,
      };
      this.setState({ fileUpload: 'uploading' });
      this.props.createFile(coregFile);
    } else {
      this.setState({ fileUpload: 'start' });
    }
  }

  upload = (wbout) => {
    const { coreg, profile } = this.props;
    this.props.hideAlert();

    if (coreg) {
      const filename = `${profile.name}-${moment().format(
        'MMDDYYhhmmss'
      )}.xlsx`;
      this.filepicker.store(
        wbout,
        { filename, base64decode: true },
        (FPFile) => {
          this.props.updateCoreg({ id: coreg.id, file_url: FPFile.url });
        },
        (FPError) => {
          this.setState({ uploading: false });
          this.props.alert(
            'error',
            'Oops! Your upload has failed. Please try again.'
          );
        }
      );
    }
  };

  handleCheck = (e) => {
    this.setState({ certify: e.target.checked });
  };

  handleNext() {
    const { fileUpload } = this.state;
    this.props.hideAlert();

    if (this.props.coreg && this.state.certify !== true) {
      this.props.alert('error', 'Please check the required field.');
    } else {
      if (fileUpload === 'uploaded') {
        this.props.loadProfile();
        this.props.router.push('/copyright-reg/complete');
      } else if (fileUpload === 'start') {
        this.props.alert('error', 'Please upload your file');
      } else {
        return;
      }
    }
  }

  setWorkTitles(data) {
    const { fields, workTypes } = this.props;
    const workTitles = fields.workTitles || [];
    const works = fields.works || [];

    let rowIndex = 0;
    workTitles.forEach((workTitle) => {
      const titles = workTitle.title.split(';');

      titles.forEach((title) => {
        const row = {
          '[3]Type of Work': getWorkTypeNameById(fields.type, workTypes),
          '[3]Work Titles': title,
        };

        if (workTitle.id !== -1) {
          const index = R.findIndex(R.propEq('id', workTitle.id))(works);

          if (index !== -1) {
            row['[3]Type of Work'] = getWorkTypeNameById(
              works[index].type,
              workTypes
            );
          }
        }

        data[rowIndex] = { ...data[rowIndex], ...row };
        rowIndex++;
      });
    });

    return [...data];
  }

  setAuthors(data) {
    const { fields } = this.props;
    const authors = fields.authors || [];

    authors.forEach((author, i) => {
      const row = {
        '[5]First Name':
          author.pseudonym.length > 0 ? author.pseudonym : author.firstName,
        '[5]Middle Name': author.middleName,
        '[5]Last Name': author.pseudonym.length > 0 ? '' : author.lastName,
        '[5]Organization Name': author.organization || '',
        '[5]Citizenship': author.citizenship,
        '[5]Domicile': author.domicile,
        '[5]Anonymous': author.anonymous === true ? 'Yes' : 'No',
        '[5]Pseudonym': author.pseudonym,
        '[5]Work made for hire?': author.workforhire === true ? 'Yes' : 'No',
        '[5]Author Created': author.contributions.join(', '),
        '[5]Author Created - other input': '',
      };

      data[i] = { ...data[i], ...row };
    });

    return [...data];
  }

  setClaimants(data) {
    const { fields } = this.props;
    const claimants = fields.claimants || [];

    claimants.forEach((claimant, i) => {
      const transfer = claimant.transfer || {};
      const row = {
        '[6]First Name': claimant.firstName,
        '[6]Middle Name': claimant.middleName,
        '[6]Last Name': claimant.lastName,
        '[6]Organization': claimant.organization || '',
        '[6]Address 1': claimant.address,
        '[6]City': claimant.city,
        '[6]State': claimant.state,
        '[6]Zip Code': claimant.zip,
        '[6]Country': claimant.country,
        '[6]Transfer Statement Type': transfer.type || '',
        '[6]Transfer Statement Other': transfer.typeOther || '',
        '[6]Owner Name': transfer.name || '',
        '[6]Owner Email': transfer.email || '',
        '[6]Owner StreetAddress': transfer.address || '',
        '[6]Owner City': transfer.city || '',
        '[6]Owner State': transfer.state || '',
        '[6]Owner Zip': transfer.zip || '',
      };

      data[i] = { ...data[i], ...row };
    });

    return [...data];
  }

  setMaterials(data) {
    const { fields } = this.props;
    const materialsExcluded = fields.materialsExcluded || [];
    const materialsIncluded = fields.materialsIncluded || {};

    let i = 0;
    Object.keys(materialsExcluded).forEach((key) => {
      if (materialsExcluded[key] === true) {
        data[i] = { ...data[i], '[7]Materials Excluded (checkbox input)': key };
        i++;
      }
    });

    i = 0;
    Object.keys(materialsIncluded).forEach((key) => {
      if (materialsIncluded[key] === true) {
        data[i] = {
          ...data[i],
          '[7]New Materials Included (Checkbox input)': key,
        };
        i++;
      }
    });

    return [...data];
  }

  loadWorkbook() {
    const { fields, profile, coreg, workTypes, subWorkTypes } = this.props;
    const questions = fields.questions || {};
    const titleTypes = fields.titleTypes || {};
    const publishInfo = fields.publishInfo || {};
    const materialsExcluded = fields.materialsExcluded || {};
    const materialsIncluded = fields.materialsIncluded || {};
    const previousRegistration = fields.previousRegistration || {};
    const authorizedAgent = fields.authorizedAgent || {};
    const certificateRecipient = fields.certificateRecipient || {};

    let data = [
      {
        '[0]User': profile.name,
        '[0]Cosynd Confirmation#': sprintf('%06d', coreg.id),
        '[2]Questionnaire Section': profile.referrer,
        '[2]Only 1 Work? (Question 1)':
          questions.question1 === true ? 'Yes' : 'No',
        '[2]Created by 1 Person? (Question 2)':
          questions.question2 === true ? 'Yes' : 'No',
        '[2]Owned 100% solely? (Question 3)':
          questions.question3 === true ? 'Yes' : 'No',
        '[3-0]Type of Work': '',
        '[3]Primary Type': fields.type
          ? getWorkTypeNameById(fields.type, workTypes)
          : '',
        '[3]Secondary Type': fields.subType
          ? getSubWorkTypeNameById(fields.subType, subWorkTypes)
          : '',
        '[3]Type of Work': '',
        '[3]Title': '',
        '[3]Larger Work Title': titleTypes.largerWork || '',
        '[3]Series Title': titleTypes.series || '',
        '[3]Previous or Alt Title': titleTypes.previousAlt || '',
        "[3]I'm Registering Entire Collection": fields.registeringTitle
          ? fields.registeringTitle === 'collection'
            ? 'YES'
            : ''
          : '',
        "[3]I'm Registering Each Title": fields.registeringTitle ? 'YES' : '',
        '[3]Work Titles': '',
        '[4]Publication/Completion': '',
        '[4]Has this work been published?':
          fields.published === true ? 'Yes' : 'No',
        '[4]Year of Completion': publishInfo.completionYear || '',
        '[4]Date of first publication':
          fields.published === true ? publishInfo.firstDate || '' : '',
        '[4]Nation of first publication':
          fields.published === true ? publishInfo.firstNation || '' : '',
        '[4]ISBN': fields.published === true ? publishInfo.isbn || '' : '',
        '[4]ISRC': fields.published === true ? publishInfo.isrc || '' : '',
        '[4]ISWC': fields.published === true ? publishInfo.iswc || '' : '',
        '[4]ISMN': fields.published === true ? publishInfo.ismn || '' : '',
        '[4]ISAN': fields.published === true ? publishInfo.isan || '' : '',
        '[4]ISTC': fields.published === true ? publishInfo.istc || '' : '',
        '[4]EIDR': fields.published === true ? publishInfo.eidr || '' : '',
        '[4]ISSN': fields.published === true ? publishInfo.issn || '' : '',
        '[4]Pre-Registration Number':
          fields.published === true ? publishInfo.preRegNum || '' : '',
        '[5]Authors': '',
        '[5]First Name': '',
        '[5]Middle Name': '',
        '[5]Last Name': '',
        '[5]Organization Name': '',
        '[5]Citizenship': '',
        '[5]Domicile': '',
        '[5]Anonymous': '',
        '[5]Pseudonym': '',
        '[5]Work made for hire?': '',
        '[5]Author Created': '',
        '[5]Author Created - other input': '',
        '[6]Claimant': '',
        '[6]First Name': '',
        '[6]Middle Name': '',
        '[6]Last Name': '',
        '[6]Organization': '',
        '[6]Address 1': '',
        '[6]City': '',
        '[6]State': '',
        '[6]Zip Code': '',
        '[6]Country': '',
        '[6]Transfer Claimant': '',
        '[6]Transfer Statement Type': '',
        '[6]Transfer Statement Other': '',
        '[6]Owner Name': '',
        '[6]Owner Email': '',
        '[6]Owner StreetAddress': '',
        '[6]Owner City': '',
        '[6]Owner State': '',
        '[6]Owner Zip': '',
        '[7]Limitation of Claim': '',
        '[7]Materials Excluded (checkbox input)': '',
        '[7]Materials Excluded (other input)': materialsExcluded['Other'] || '',
        '[7]1st Prev. Reg. #': previousRegistration.firstNumber || '',
        '[7-1]Year': previousRegistration.firstYear || '',
        '[7]2nd Prev. Reg. #': previousRegistration.secondNumber || '',
        '[7-2]Year': previousRegistration.secondYear || '',
        '[7]New Materials Included (Checkbox input)': '',
        '[7]New Materials Included (other input)':
          materialsIncluded['Other'] || '',
        '[8]Rights & Permissions': '',
        '[8]First Name': authorizedAgent.firstName || '',
        '[8]Middle Name': authorizedAgent.middleName || '',
        '[8]Last Name': authorizedAgent.lastName || '',
        '[8]Organization': authorizedAgent.organization || '',
        '[8]Email': authorizedAgent.email || '',
        '[8]Phone': authorizedAgent.tel || '',
        '[8]Address 1': authorizedAgent.address || '',
        '[8]City': authorizedAgent.city || '',
        '[8]State': authorizedAgent.state || '',
        '[8]Postal Code': authorizedAgent.zip || '',
        '[8]Country': authorizedAgent.country || '',
        '[0]Corresponant - always Cosynd': '',
        '[0]Organization (Default to Cosynd Data)':
          CosyndDefaultData.Organization,
        '[0]Email (Default to Cosynd Data)': CosyndDefaultData.Email,
        '[0]Phone (Default to Cosynd Data)': CosyndDefaultData.Phone,
        '[0]Address 1 (Default to Cosynd Data)': CosyndDefaultData.Address,
        '[0]City (Default to Cosynd Data)': CosyndDefaultData.City,
        '[0]State (Default to Cosynd Data)': CosyndDefaultData.State,
        '[0]Postal Code (Default to Cosynd Data)': CosyndDefaultData.Postal,
        '[0]Country (Default to Cosynd Data)': CosyndDefaultData.Country,
        '[9]Mail Certificate': '',
        '[9]First Name': certificateRecipient.firstName || '',
        '[9]Middle Name': certificateRecipient.middleName || '',
        '[9]Last Name': certificateRecipient.lastName || '',
        '[9]Email': certificateRecipient.email || '',
        '[9]Phone': certificateRecipient.tel || '',
        '[9]Organization': certificateRecipient.organization || '',
        '[9]Address 1': certificateRecipient.address || '',
        '[9]City': certificateRecipient.city || '',
        '[9]State': certificateRecipient.state || '',
        '[9]Zip/Postal Code': certificateRecipient.zip || '',
        '[9]Country': certificateRecipient.country || '',
        '[0]Certification': '',
        '[0]Name of Certifying Individual (Cosynd Default)': '',
        '[0]eCo Case #': '',
        '[0]Date/Time Submitted': moment().format('M/D/YY H:m:s'),
      },
    ];

    data = this.setWorkTitles(data);
    data = this.setAuthors(data);
    data = this.setClaimants(data);
    data = this.setMaterials(data);

    return getWorkbookData([{ name: 'Copyright Registration', data }]);
  }

  render() {
    const { fields } = this.props;
    const { certify, fileUpload } = this.state;
    const workTitles = fields.workTitles || [];

    return (
      <div className="submit-form">
        <Heading text="You’re almost done! Now, you need to upload your work to us." />

        <div className="content">
          <FormGroup>
            <h3 className="text-primary">
              Click "Browse" to select your ({workTitles.length}){' '}
              {workTitles.length === 1 ? 'file' : 'files'}:
            </h3>
            <FileUploader
              onUpload={(files) => this.handleUpload(files)}
              text="Upload"
              fileUpload={fileUpload}
              workTitles={workTitles}
            >
              <button className="btn-upload">Browse</button>
            </FileUploader>
          </FormGroup>

          <h3 className="text-line-height">
            To finalize your application, select all of your files at once.
            <br />
            Choose one file for each title you listed on your application.
          </h3>
          <ul>
            <li>
              Choose one file for each title you listed on your application.
            </li>
            <li>Each file size must be below 500MB.</li>
            <li>
              After uploading your files, match each file to a title from your
              application then click “Upload” to complete the submission.
            </li>
          </ul>
          <h3 className="text-line-height">
            Cosynd does not review the entirety of your file submission.
            <br />
            Submitting extra material may cause your application to be denied by
            The Copyright Office.
            <br />
          </h3>

          <Checkbox checked={certify === true} onChange={this.handleCheck}>
            <span className="text-red">*</span>By checking this box, I certify
            that the information I have provided is true.
          </Checkbox>
          <br />
        </div>

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  status: state.coreg.status,
  profile: state.profile,
  fields: state.coreg.fields,
  coreg: state.coreg.coreg,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypesCoreg,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  resetAttribute: () => {
    dispatch(actions.resetCoregAttribute());
  },
  createFile: (coregFile) => {
    dispatch(actions.createCoregFile(coregFile));
  },
  updateCoreg: (coreg) => {
    dispatch(actions.updateCoreg(coreg));
  },
  loadProfile: () => {
    dispatch(actions.getProfile());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitForm);



// WEBPACK FOOTER //
// src/components/Copyright/SubmitForm.jsx